import React from 'react';

import { createStyles, Theme, withStyles } from '@material-ui/core/styles';
import {
  Button,
  TextField,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Paper,
  Grid,
  DialogActions
} from '@material-ui/core';
import { Close as CloseIcon } from '@material-ui/icons';
// import RfsStyles from '';
import RfsStyles from '../rfs/rfs.module.css';
import commonStyles from '../common/common.module.css';
import MaterialTable from 'material-table';
import Zoom from '@material-ui/core/Zoom';
import moment from 'moment';
import AwbsDataTable from '../../models/AwbsDataTable';
import Awb from '../../models/Awb';
import User from '../../models/User';

const styles = (theme: Theme) =>
  createStyles({
    rowContainer: {
      paddingLeft: 20,
      paddingRight: 20,
    },
    button: {
      width: '100%',
      height: '34px',
      textTransform: 'none',
    },
    warning: {
        color: 'red'
    },
    materialIcon: {
      margin: '10px 3px 0',
      fontSize: 20,
      '&:hover': {
        cursor: 'pointer',
      },
    },
  });

interface MultipleAwbProps {
  classes: any;
  modalOpen: boolean;
  handleClose: (type: string) => void;
  awbHistory: Array<Awb>;
  proceed: Function;
  selectAwb: Function;
  awb: Awb;
  user: User;
};

const multipleAwbs = (props: MultipleAwbProps) => {
  const { classes } = props;

  return (
    <Dialog
      open={props.modalOpen}
      onClose={() => props.handleClose('history')}
      aria-labelledby='form-dialog-title'
      maxWidth={'md'}
      fullWidth={true}
      TransitionComponent={Zoom}
      transitionDuration={500}>
      <DialogTitle id='form-dialog-title'>
        <div className={RfsStyles.dialogTitle}>
          <span className={RfsStyles.name}>Multiple AWB records detected</span>
          <IconButton
            aria-label='Close'
            className={RfsStyles.close}
            onClick={() => props.handleClose('history')}>
            <CloseIcon color='primary' />
          </IconButton>
        </div>
        <hr />
      </DialogTitle>
      <DialogContent>
        <div>The Air waybill number you are querying has more than one record in the system.</div>
        <div>Please select the one you wish to view.</div>
        <div className= { `${ commonStyles.wrapper } ${ RfsStyles.tblWrapper }  ${ commonStyles.paperTable } ${ commonStyles.SelectTable }` }>
          <h3 className={ commonStyles.header }> Shipment Details </h3>
          <MaterialTable
            components={{Container: props => <Paper {...props} elevation={0} className={ commonStyles.paperTable }/>}}
            onRowClick={ (event: any, rowData: any) => (rowData.id_gha !== props.user.gha_id) ? null : props.selectAwb(rowData) }
            columns={[
                {
                    title: 'AWB',
                    field: '',
                    render: (awb: Awb) => {
                  return `${awb.code}-${awb.number}`;
                }
                  },
              {
                title: 'Flight',
                field: '',
                render: (awb: Awb) => {
                  return <div>{`${awb.flight_no}/${moment(awb.arrival_date && awb.arrival_date.trim().length ? awb.arrival_date : awb.export_metadata.firstFlightDate).format('DD-MMM-YYYY')}`}</div> ;
                },
              },
              {
                title: 'Pcs',
                field: 'pieces'
              },
              {
                title: 'Weight',
                field: 'weight',
              },
              {
                title: 'Origin',
                field: 'origin'
              },
              {
                title: 'Dest',
                field: 'destination',
              },
              {
                title: 'Status',
                field: 'status',
              },
            ]}
            data={props.awbHistory}
            options={{
              maxBodyHeight: 205,
              paging: false,
              pageSize: 10,
              headerStyle: {
                backgroundColor: 'var(--tbl_head_bkg)',
                color: 'var(--tbl_head_color)',
                zIndex: 2,
              },
              rowStyle: (rowData: any) => ({
                color: (props.awb === rowData) ? '#fff' : '#000',
                transition: '0s',
                backgroundColor: (rowData.id_gha !== props.user.gha_id) ? 'gray' : 'transparent', // Adjust the condition and styling as needed
                pointerEvents: (rowData.id_gha !== props.user.gha_id) ? 'none' : 'auto'
              }),
              showTitle: false,
              pageSizeOptions: [15, 20],
              toolbar: false,
              sorting: false,
            }}
          />
        </div>
      </DialogContent>
      <DialogActions>

        <Button
          className={classes.submitBtn}
          variant="contained"
          color="primary"
          onClick={() => props.proceed('step1')}
          disabled={ !props.selectAwb }
        >
        Submit
        </Button>
        <Button
          className={classes.submitBtn}
          variant="contained"
          color="primary"
          onClick={() => props.handleClose('history')}
        >
          Cancel
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default withStyles(styles)(multipleAwbs);
